import axiosInstance from "../../../utils/axiosInstance"
import { BASE_URL, API_ENDPOINT_EDIT_USER , API_ENDPOINT_LOGOUT_USER} from "../../../utils/constants";
import { createAsyncThunk } from "@reduxjs/toolkit";

const editUser = createAsyncThunk("user/edit", async (data, thunkAPI) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}${API_ENDPOINT_EDIT_USER}`, data);
    const responseData = await res.data;
    return responseData;
  } catch (error) {
    return thunkAPI?.rejectWithValue(error?.response?.data);
  }
});

const logoutUser = createAsyncThunk("user/logout", async (data, thunkAPI) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}${API_ENDPOINT_LOGOUT_USER}`, data);
    const responseData = await res.data;
    return responseData;
  } catch (error) {
    return thunkAPI?.rejectWithValue(error?.response?.data);
  }
});

export { editUser, logoutUser };
